<template>
  <b-container class="my-5">
    <a v-b-toggle.collapse-3 class="h5">Year</a>
    <b-collapse visible id="collapse-3">
      <template v-for="year in years">
        <b-row class="justify-content-center my-2" :key="year">
          <a href="www.google.com">{{ year }}</a>
        </b-row>
      </template>
    </b-collapse>
  </b-container>
</template>
<script>
export default {
  data() {
    return {
      years: [
        "2019",
        "2017-2019",
        "2014-2016",
        "2013",
        "2011",
        "2010",
        "2009",
        "2008",
        "2007",
        "2005-2006",
        "2004",
        "2003",
        "2001-2002",
        "1998-2000"
      ]
    };
  }
};
</script>